import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-450eedcf"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "page"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title animated fadeInDown"
  }, [/*#__PURE__*/_createTextVNode(" 你读过的书，终将成为你的气质和风骨 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 滋养着你的生长！ ")], -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "device"
  }, "BC60启明星", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "tags"
  }, "待更新中...", -1);
});

var _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5);
}